export default {
  tabs: {
    register: '會員註冊',
    scan: '掃碼設置',
    right: '會員權益說明',
    privacy: '會員隱私協議',
  },
  register: {
    conditions: '帳號註冊條件',
    phone: '手機號',
    phoneCode: '手機驗證碼',
    email: '郵箱',
    emailCode: '郵箱驗證碼',
    saveRule: '請至少勾選一種登錄方式，並勾選對應的驗證方式',
    savePhoneVerifyRule: '請勾選手機號裡面的驗證方式',
    saveEmailVerifyRule: '請勾選郵箱裡面的驗證方式',
  },
  scan: {
    label: '每掃碼',
    countSuffix: '次，增加',
    growthSuffix: '成長值',
    countPlaceholder: '請輸入次數',
    valuePlaceholder: '請輸入',
    tooltip: '消費者掃描系統產品二維碼時（有效掃碼次數，即首次掃碼是該消費者），會根據掃碼次數來增加成長值',
    saveCountRule: '請輸入掃碼次數',
    saveValueRule: '請輸入成長值',
  },
  agreement: {
    title: '會員權益說明',
    viewTip: '（用戶端可查看會員權益說明）',
    intro: '編輯會員協議內容，可針對不同語言維護各自的版本。',
    language: '語言',
    addLang: '新增多語言',
    delete: '刪除',
    editorPlaceholder: '請輸入內容',
    saveBeforeSwitch: '當前內容尚未保存，是否保存？',
  },
  rules: {
    title: '規則說明',
    intro1: '1、會員隱私協議主要用於向消費者解釋說明會員中心如何收集、使用和共享用戶的個人信息，包括數據的用途、保存方式、安全性等方面的詳細信息，在用戶進入會員中心功能時，需要同意該協議內容才能繼續使用。',
    intro2: '2、如面向多國用戶使用，需分別維護不同國家語言的會員隱私協議，保障合規展示',
    intro: '編輯會員規則說明內容，可針對不同語言維護各自的版本。',
    titleField: '標題',
    language: '語言',
    addLang: '新增多語言',
    delete: '刪除',
    saveBeforeSwitch: '當前內容尚未保存，是否保存？',
  },
  addI18nModal: {
    titleAgreement: '新增協議',
    titleRules: '新增規則說明',
    language: '語言',
    languagePlaceholder: '請選擇語言',
    content: '內容',
  },
  deleteConfirm: '刪除後不可恢復，確定要刪除嗎？',
};
